import React from 'react'
import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {Toggle} from '@vio/atlas/Toggle'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {PriceToggleRow} from '@vio/shared/src/search/PriceToggleRow'

const Subtitle = styled(Text)`
  color: ${cssTheme.colors.content.neutral.secondary};
`

interface Props {
  checked: boolean
  onChange: () => void
  toggleMessage?: React.ReactNode
  totalPriceMessage: React.ReactNode
}

export const TotalPriceToggleMobile: React.FC<Props> = ({
  checked,
  onChange,
  totalPriceMessage
}) => {
  return (
    <PriceToggleRow>
      <div>
        <Text variant="labelS">
          <FormattedMessageWrapper
            id="showTotalPrice"
            defaultMessage="Show total price"
          />
        </Text>
        <Subtitle variant="bodyXS">{totalPriceMessage}</Subtitle>
      </div>
      <Toggle id="TotalPriceToggle" checked={checked} onChange={onChange} />
    </PriceToggleRow>
  )
}
